import React, { useContext, useEffect, useState } from "react";
import { StyledBadgeNotification } from "./styledBadges";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { HTTP_STATUSES } from "../../../utils/consts";
import { AppContext } from "../../../App";

const TransferBadge = () => {
  const { user } = useContext(AppContext);

  const [count, setCount] = useState(null);

  const fetchBadgeInfo = () => {
    axios.get("/api/transfers/badges/count", userAuthenticationConfig()).then(response => {
      if(response.status === HTTP_STATUSES.HTTP_OK && "count" in response.data) {
        setCount(response.data.count);
      }
    })
  };

  // TODO Add pusher
  useEffect(() => {
    fetchBadgeInfo();
  }, []);

  const getBadgeCount = () => {
    if(!count || count === "0") {
      return (
        <></>
      )
    }

    return (
      <StyledBadgeNotification>
        {count}
      </StyledBadgeNotification>
    )
  }

  return (
    getBadgeCount()
  );
}

export default TransferBadge;